import { useState, useEffect, useCallback } from "react";
import {
  Button,
  Typography,
  Divider,
  Box,
  Card,
  Stack,
  List,
  ListItem,
  IconButton,
  ListItemButton,
  ListItemText
} from "@mui/material";
import InfiniteScroll from "react-infinite-scroll-component";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import moment from "moment";
import { useSelector } from "react-redux";
import { GET_USER_REWARD_ACTIVITIES } from "../../constant/Apipath";
import { Getrequestcall } from "../../request/Getrequest";
import Loader from "../../common/Loader";
import Emptydata from "../common/Emptydata";
import { BILightGrey } from "../../assets/helpers";
import { English } from "../../constant/EnglishFallback";
import bucksIcon from "../../assets/images/bucks.png";

function AccountActivity() {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const userId = loginData?.userInformation?.UserId;
  const [activities, setActivities] = useState([]);
  const [accountActivity, setAccountActivity] = useState([]);
  const [activeTab, setActiveTab] = useState("All");
  const [loading, setLoading] = useState(false);
  const [expandedId, setExpandedId] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  const LanguageData = multiLanguageData?.RewardStore || {};
  const {
    TEXT_ALL_ACTIVITY = English.RewardStore.TEXT_ALL_ACTIVITY,
    TEXT_EARNINGS_ACTIVITY = English.RewardStore.TEXT_EARNINGS_ACTIVITY,
    TEXT_SPENDINGS_ACTIVITY = English.RewardStore.TEXT_SPENDINGS_ACTIVITY,
    TEXT_DEDUCTIONS_ACTIVITY = English.RewardStore.TEXT_DEDUCTIONS_ACTIVITY,
    TEXT_PLACEHOLDER_NO_DATA = English.RewardStore.TEXT_PLACEHOLDER_NO_DATA,
    TEXT_TODAY = English.RewardStore.TEXT_TODAY,
    TEXT_YESTERDAY = English.RewardStore.TEXT_YESTERDAY
  } = LanguageData || {};

  let myRewardsArray = [
    { name: "All", value: TEXT_ALL_ACTIVITY },
    { name: "Earnings", value: TEXT_EARNINGS_ACTIVITY },
    { name: "Spending", value: TEXT_SPENDINGS_ACTIVITY },
    { name: "Deductions", value: TEXT_DEDUCTIONS_ACTIVITY }
  ];

  useEffect(() => {
    const filteredActivities = activities.filter((activity) => activity.activityDescription);
    setAccountActivity(filteredActivities);
  }, [activities]);

  const removeDuplicates = (originalArray, prop) => {
    const newArray = [];
    const lookupObject = {};
    for (const i in originalArray) {
      lookupObject[moment(originalArray[i][prop]).format("MMM DD, YYYY")] = originalArray[i];
    }
    for (const i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  };

  const getData = useCallback(
    async (type) => {
      try {
        setLoading(true);
        const userRewardUrl = `${GET_USER_REWARD_ACTIVITIES}/${userId}/${type}/${1}/${20}`;
        const activityRes = await Getrequestcall(userRewardUrl, loginData?.accessToken);
        const result = activityRes?.data?.data;
        const newResult = JSON.parse(JSON.stringify(result));
        const allUnique = removeDuplicates(newResult, "activityDate");

        let a = [];
        const allActivities = allUnique.map((unique) => {
          a = unique;
          a["data"] = [];
          a["titleDate"] = unique.activityDate;
          result.forEach((data) => {
            if (
              moment(data.activityDate).format("MMM DD, YYYY") ===
              moment(unique.activityDate).format("MMM DD, YYYY")
            ) {
              const obj = { ...data, isExpanded: false };
              a["data"].push(obj);
            }
          });
          return a;
        });
        setAccountActivity(allActivities);
        setActivities(allActivities);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        console.log("getData-> Error While Getting The Account Activity Data: ", err);
      }
    },
    [userId, loginData]
  );

  const onTabChange = async (type) => {
    setActiveTab(type);
  };

  const getFormattedDate = (date) => {
    const mDate = moment(date);
    return mDate.isSame(moment(), "day")
      ? TEXT_TODAY
      : mDate.isSame(moment().subtract(1, "day"), "day")
        ? TEXT_YESTERDAY
        : mDate.format("MMM DD, YYYY");
  };

  useEffect(() => {
    getData(activeTab);
    setExpandedId(null);
  }, [activeTab, getData]);

  const renderActivityItems = (activity) => (
    <>
      <Typography variant="body2" sx={{ color: "GrayText", padding: "10px" }}>
        {getFormattedDate(moment(activity.titleDate))}
      </Typography>
      <Stack sx={{ gap: 1, py: 0.5 }}>
        {activity?.data?.map((item, index) => (
          <Card key={index.toString()} className="pagelist-content">
            <ListItem sx={{ m: 0, p: 0, alignItems: "center" }} key={index.toString()} disablePadding secondaryAction={ <Stack direction={"row"} spacing={1} sx={{ alignItems: "center" }}>
                  <Typography variant="body1" sx={{ color: item.bucks > 0 ? "success.main" : "error.main", display: "inline-flex", alignItems: "center" }}>
                    {item.bucks > 0 ? `+${item.bucks}` : item.bucks} {" "} <img src={bucksIcon} alt="Builder Bucks" style={{ width: 18, height: 22, marginLeft: 6 }} />
                  </Typography>
                  <IconButton
                    onClick={() => {
                      setExpandedId((preValue) => (preValue !== item?.id ? item?.id : null));
                    }}>
                    {expandedId === item?.id ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                  </IconButton>
                </Stack>
              }>
              <ListItemButton
                onClick={() => {
                  setExpandedId((preValue) => (preValue !== item?.id ? item?.id : null));
                }}>
                <ListItemText
                  primary={
                    item.appName === "Questions"
                      ? "Answered a question"
                      : item.appName === "Purchase"
                        ? "Entered to Win"
                        : item.title
                  }
                />
              </ListItemButton>
            </ListItem>

            {expandedId === item?.id && (
              <>
                <Divider />
                <Stack sx={{ p: 2,  backgroundColor: BILightGrey }} >
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    {item?.activityDescription?.replaceAll("<", "")?.replaceAll(">", "")}
                  </Typography>
                </Stack>
              </>
            )}
          </Card>
        ))}
      </Stack>
    </>
  );

  const updatePageNumber = (callback) => {
    setPageNo((prevPageNr) => prevPageNr + 1);
    callback(pageNo + 1);
  };

  const getNextAccountActivityData = async (pageNr) => {
    try {
      setAllDataLoaded(true);
      const userRewardUrl = `${GET_USER_REWARD_ACTIVITIES}/${userId}/${activeTab}/${pageNr}/${20}`;
      const activityRes = await Getrequestcall(userRewardUrl, loginData?.accessToken);
      const result = activityRes?.data?.data;
      const newResult = JSON.parse(JSON.stringify(result));
      const allUnique = removeDuplicates(newResult, "activityDate");

      let a = [];
      const allActivities = allUnique.map((unique) => {
        a = unique;
        a["data"] = [];
        a["titleDate"] = unique.activityDate;
        result.forEach((data) => {
          if (
            moment(data.activityDate).format("MMM DD, YYYY") ===
            moment(unique.activityDate).format("MMM DD, YYYY")
          ) {
            const obj = { ...data, isExpanded: false };
            a["data"].push(obj);
          }
        });
        return a;
      });
      setAccountActivity((preValue) => [...preValue, ...allActivities]);
      setActivities((preValue) => [...preValue, ...allActivities]);
      setAllDataLoaded(false);
    } catch (err) {
      setAllDataLoaded(false);
      console.log(
        "getNextAccountActivityData-> Error While Getting User Reward Activity Data: ",
        err
      );
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Stack direction={"row"} spacing={1} sx={{ pb: 1 }}>
            {myRewardsArray.map((menu, index) => {
              const isSelected = menu.name === activeTab;
              return (
                <Button
                  size="small"
                  key={index}
                  label={menu.value}
                  variant={isSelected ? "contained" : "outlined"}
                  onClick={() => onTabChange(menu.name)}>
                  {menu.value}
                </Button>
              );
            })}
          </Stack>
          <Divider />
          <Box className="main-content-card-list" id="scrollablediv_prodcut">
            {accountActivity.length !== 0 ? (
              <InfiniteScroll
                dataLength={accountActivity.length}
                next={() => {
                  updatePageNumber(async (pageNr) => {
                    await getNextAccountActivityData(pageNr);
                  });
                }}
                loader={
                  !allDataLoaded ? null : (
                    <h4 style={{ display: "flex", justifyContent: "center" }}>
                      <Loader />
                    </h4>
                  )
                }
                hasMore={true}
                scrollableTarget="scrollablediv_prodcut">
                <Stack sx={{ gap: 2 }}>
                  {accountActivity?.map((item, index) => (
                    <Box key={index}>{renderActivityItems(item)}</Box>
                  ))}
                </Stack>
              </InfiniteScroll>
            ) : (
              <Box className="empty-data-card">
                <Emptydata firstText={TEXT_PLACEHOLDER_NO_DATA} />
              </Box>
            )}
          </Box>
        </>
      )}
    </>
  );
}

export default AccountActivity;
